import { defineComponent } from "vue";

export default defineComponent({
    template: `
        <div class="Breadcrumb" :class="{ 'Breadcrumb--sme': sme }">
            <div class="Breadcrumb__inner">
                <div class="Breadcrumb__label">Krok {{ step }}: {{ label }}</div>

                <div class="Breadcrumb__steps">
                    <div
                        v-for="i in sme ? [1, 2, 3, 4] : [1, 2, 3]" 
                        class="Breadcrumb__step"
                        :class="{ 'Breadcrumb__step--active': step >= i, 'Breadcrumb__step--current': step == i }, [ 'Breadcrumb__step-' + i ]"
                    ></div>
                </div>
            </div>
        </div>
    `,

    props: {
        step: { type: Number, required: true },
        sme: { type: Boolean, default: false },
    },

    computed: {
        label() {
            if (this.sme) {
                switch (this.step) {
                    case 1:
                        return 'Dane firmy';

                    case 2:
                        return 'Dane do umowy';

                    case 3:
                        return 'Dane osobowe i zgody';

                    case 4:
                        return 'Umowa';
                }
            } else {
                switch (this.step) {
                    case 1:
                        return 'Dane do umowy';

                    case 2:
                        return 'Dane osobowe i zgody';

                    case 3:
                        return 'Umowa';
                }
            }
        },
    },
});
